import React, { useState } from "react";
import { Button, Card, Col, Container, Row, Spinner, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { deleteUser, fetchUsers } from "../../services/httpClient";
import { User } from "../../types/user";
import useApp from "../../utils/useApp";
import PageTitle from "../ui/PageTitle";

interface UserTabState {
  users: User[];
  setUsers: any;
  type: string;
  displayType: string;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const UserTab = ({ users, setUsers, type, displayType, setShowToast, setToastText, setToastBody }: UserTabState) => {
  const { auth }: any = useApp();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [userToDelete, setUserToDelete] = useState<User>();

  let navigate = useNavigate();

  const editUser = (e: any) => {
    navigate(`/users/user/${e}`);
  };

  const CreateNewUser = (e: any) => {
    navigate(`/users/user/create/${type}`);
  };

  const onClickDelete = (e: any) => {
    setIsDeleting(true);
    setUserToDelete(e);
  };

  const onClickDeleteFinal = () => {
    setIsLoading(true);

    deleteUser(userToDelete?.id)
      .then(() => {
        setIsDeleting(false);
        setShowToast(true);
        setToastText("User Deleted");
        setToastBody(userToDelete?.firstname + " " + userToDelete?.lastname);
        setUserToDelete(undefined);

        fetchUsers()
          .then((res: any) => {
            const userList = res[0].data;
            setUsers(userList);
            setIsLoading(false);
          })
          .catch((err: any) => {
            console.log(err);
            setIsLoading(false);
          });
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const onClickCancelDelete = () => {
    setIsDeleting(false);
    setUserToDelete(undefined);
  };

  const renderDelete = () => {
    return (
      <Card className="bg-light">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Stack style={{ justifyContent: "center" }}>
              <Card.Subtitle>Are you sure you want to delete {userToDelete?.firstname + " " + userToDelete?.lastname}?</Card.Subtitle>
            </Stack>
            <Button className="app-danger-color button" onClick={() => onClickDeleteFinal()}>
              Confirm Delete
            </Button>
            <div className="vr" />
            <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
              Cancel
            </Button>
          </Stack>
        </Card.Body>
      </Card>
    );
  };

  const renderCannotDeleteThemself = () => {
    return (
      <Card className="bg-light">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Stack style={{ justifyContent: "center" }}>
              <Card.Subtitle>You cannot delete your own {displayType} account.</Card.Subtitle>
            </Stack>
            <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
              Cancel
            </Button>
          </Stack>
        </Card.Body>
      </Card>
    );
  };

  const renderCannotDeleteAll = () => {
    return (
      <Card className="bg-light">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Stack style={{ justifyContent: "center" }}>
              <Card.Subtitle>You cannot delete the only {displayType} account.</Card.Subtitle>
            </Stack>
            <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
              Cancel
            </Button>
          </Stack>
        </Card.Body>
      </Card>
    );
  };

  return (
    <Row>
      <Col xs={12}>
        <Stack gap={3}>
          <PageTitle
            title={
              type === "org_admin"
                ? "Org Admin Users"
                : type === "admin"
                ? "Admin Users"
                : type === "case_manager"
                ? "Case Manager Users"
                : type === "res_support"
                ? "Residential Support Users"
                : "Support Users"
            }
            type="section"
            buttonTitle="Create User"
            onButtonClick={CreateNewUser}
          />
          {isDeleting ? (
            userToDelete?.id === auth?.profile?.id ? (
              <>{renderCannotDeleteThemself()}</>
            ) : users?.length === 1 && (type === "org_admin") ? (
              <>{renderCannotDeleteAll()}</>
            ) : (
              <>{renderDelete()}</>
            )
          ) : isLoading ? (
            <Container className="div-main">
              <Button size="sm" className="spinner-button spinner-button-main">
                <Spinner animation="border" style={{ color: "#F6893D" }} />
              </Button>
            </Container>
          ) : (
            <>
              {users.length === 0 && <p className="mt-2">No {displayType} User Records</p>}
              {users.map((user: any) => (
                <Card key={user.id} className="bg-light">
                  <Card.Body>
                    <Stack direction="horizontal" gap={3}>
                      <Stack className="cursor-pointer" onClick={(e) => editUser(user.id)}>
                        <Card.Subtitle>
                          {user.firstname} {user.preferredname ? "'" + user.preferredname + "'" : ""} {user.lastname}
                        </Card.Subtitle>
                        <Card.Subtitle className="text-muted mt-1">{user.email} </Card.Subtitle>
                      </Stack>
                      {user.cases && <Card.Subtitle className="text-muted mt-1">{user.cases?.length + " Cases"} </Card.Subtitle>}
                      <Button className="app-secondary-color button" onClick={(e) => editUser(user.id)}>
                        Edit
                      </Button>
                      <div className="vr" />
                      <Button className="app-danger-color button" onClick={(e) => onClickDelete(user)}>
                        Delete
                      </Button>
                    </Stack>
                  </Card.Body>
                </Card>
              ))}
            </>
          )}
        </Stack>
      </Col>
    </Row>
  );
};

export default UserTab;
